import { AbstractControl } from '@angular/forms';

export enum QuickDateTimeSelection {
  '24H' = '24h',
  '72H' = '72h',
  '7D' = '7D',
  '28D' = '28D'
}

/**
 * Get date / time error msg.
 * @param fc
 */
export const getErrorKey = (fc: AbstractControl): string => {
  if (fc.hasError('matDatepickerParse') ||
      fc.hasError('matTimepickerParse')) {
    return 'DATES.DATE_PICKER_ERRORS.FORMAT';
  } else if (fc.hasError('matTimepickerMin') ||
      fc.hasError('matTimepickerMax') ||
      fc.hasError('matDatepickerMin') ||
      fc.hasError('matDatepickerMax') ||
      // in case mat-date-range-input below validators are there out-of-the-box
      fc.hasError('matStartDateInvalid') ||
      fc.hasError('matEndDateInvalid')
  ) {
    return 'DATES.DATE_PICKER_ERRORS.INVALID';
  } else if (fc.hasError('required')) {
    return 'DATES.DATE_PICKER_ERRORS.REQUIRED';
  } else return '';
}